import './About.css'

const About = () => {
  return (
    <div className='about-container'>
      <h2>About Me</h2><br />
      <p>I'm Taranpreet Singh, an aspiring MERN stack developer based in Delhi NCR.<br />
        This is my first major full stack application.
        I'm a self-taught, self-driven individual who likes to create valuable
        solutions with their skills. I seek new challenges that help me learn
        and grow into a better version of myself. My biggest strength is my
        short learning curve and the ability to reinvent myself under different
        challenges and ever-changing roles. I have completed my bachelors
        degree, and am actively looking for any opportunities that might benefit
        from my technical and soft skills.
      </p>
      <br />
      <span><a rel="noreferrer" href="https://drive.google.com/file/d/1BzGrm-EXg3yLTxAH8VHM3KqN_GcyG4qJ/view?usp=sharing" target="_blank">View my resume!</a></span>
      <br />
      <span>My contact details: <br />Phone Number: +91 9953465989<br />Email: taranpreetsingh29@gmail.com</span>
      <br />
      <span>My <a rel="noreferrer" href="https://github.com/Taran29/" target="_blank">Github</a> and <a rel="noreferrer" href="https://www.linkedin.com/in/taranpreet-singh-b48881192/" target="_blank">LinkedIn</a></span>

      <p>Repo for this project: <a rel="noreferrer" href="https://github.com/Taran29/SurveyApp" target="_blank">Frontend</a> and <a rel="noreferrer" href="https://github.com/Taran29/SurveyAppServer" target="_blank">Backend</a></p>
    </div>
  )
}

export default About